// client/src/App.js
import React, { useState, useEffect } from 'react';
import './App.css';
import './components/DailyFocusTool.css';
import phokiiLogo from './assets/phokii.png';
import DailyFocusTool from './components/DailyFocusTool';
import Auth from './components/Auth';

function App() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const savedToken = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    
    console.log('🔍 Checking stored auth:', { savedToken: !!savedToken, savedUser: !!savedUser });
    
    if (savedToken && savedUser) {
      try {
        setToken(savedToken);
        setUser(JSON.parse(savedUser));
        console.log('✅ Found valid stored auth, user should be logged in');
      } catch (error) {
        console.error('❌ Error parsing saved user data:', error);
        // Clear invalid data
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        console.log('🧹 Cleared invalid stored data');
      }
    } else {
      console.log('🔑 No stored auth found, should show login screen');
    }
    
    setLoading(false);
  }, []);

  const handleLogin = (userData, authToken) => {
    setUser(userData);
    setToken(authToken);
  };

  const handleLogout = () => {
    console.log('🔒 Logging out');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    setToken(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!user || !token) {
    // The landing page owns the front door. Fresh visitors bounce to
    // /welcome; the Auth screen renders only when explicitly asked for
    // (?signin=1 from the landing) or mid password-reset (?reset=TOKEN).
    const params = new URLSearchParams(window.location.search);
    // Never redirect from /welcome itself — on the dev server the SPA answers
    // that path too, and redirecting again would loop forever.
    if (!params.get('signin') && !params.get('reset') && window.location.pathname !== '/welcome') {
      window.location.replace('/welcome');
      return null;
    }
    return <Auth onLogin={handleLogin} />;
  }


  return (
    <div className="App">
      <DailyFocusTool token={token} user={user} onLogout={handleLogout} />
    </div>
  );
}


export default App;